import React from 'react';

import { BaseComponent, IStateBase } from 'components/BaseComponent';
import Menu from '@material-ui/core/Menu/Menu';
import { enLang, enCurrency } from 'interfaces/IProductData';
import { langService } from 'services/LangService';
import Avatar from '@material-ui/core/Avatar/Avatar';
import { SvgIcon } from 'components/SvgIcon';
import LangItem from './LangItem';
import { WithStyles } from 'shared/decorators/withStyles';

interface IState extends IStateBase {
  anchorEl: any;
  options: { lang: enLang; text: string; currency: enCurrency }[];
  lang: string;
}

@WithStyles(() => ({
  '@global': {
    '.country-menu-item': {
      lineHeight: '15px',

      '& img': {
        height: '15px',
        width: '20px',
        marginRight: '3px'
      },

      '& svg': {
        width: '15px',
        marginRight: '5px'
      }
    }
  },
  component: {
    '&.chk-config-country': {
      float: 'right',

      '& img': {
        height: '15px',
        width: '15px',
        marginTop: '-5px'
      },

      '& .chk-config-button': {
        position: 'relative',
        display: 'inline-block',
        padding: '2px 25px 2px 5px',
        border: '1px solid #cecece',
        borderRadius: '4px',
        width: 'auto',

        '& svg': {
          width: '15px'
        },

        '& .chk-option-active': {
          marginLeft: '10px',
          fontSize: '12px',
          color: '#232323',
          display: 'inline-block',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          height: '21px',
          lineHeight: '28px'
        }
      }
    },

    '& .chk-configCountry___avatar': {
      alignSelf: 'flex-end',
      position: 'absolute',
      margin: '45px 20px',

      '& img': {
        height: '32px',
        width: '32px'
      }
    }
  }
}))
export default class ConfigCountry extends BaseComponent<IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      anchorEl: null,
      options: [
        { lang: enLang.PT_BR, text: 'Brasil - R$ BRL', currency: enCurrency.BRL },
        { lang: enLang.PT_PT, text: 'Portugal - US$ USD', currency: enCurrency.USD },
        { lang: enLang.EN_US, text: 'Internacional - US$ USD', currency: enCurrency.USD }
      ],
      lang: null
    };
  }

  componentDidMount() {
    this.observeState({ lang: null }, langService.getLang());
  }

  close = () => {
    this.setState({ anchorEl: null });
  };

  open = (event: any) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  selectLang = (lang: enLang) => {
    langService.setLang(lang);
    this.close();
  };

  render() {
    const { anchorEl, options, lang } = this.state;

    if (!lang) {
      return <div />;
    }

    const selectedLang = options.find(o => o.lang == lang);

    return (
      <div
        className={`chk-config-country ${!this.props.circle ? '' : 'chk-configCountry___avatar'} ${this.props.classes.component}`}
        id="chk-config-country"
      >
        {this.props.circle ? (
          <div className={'classes.row'}>
            <Avatar id="chk-selectlang-circle-button" onClick={this.open} alt={selectedLang.text} className={'classes.avatar'}>
              <SvgIcon name={`flag_${selectedLang.lang}_round`} />
            </Avatar>
          </div>
        ) : (
          <a id={`chk-selectlang-button-${lang}`} className="chk-config-button" onClick={this.open}>
            <SvgIcon name={`flag_${selectedLang.lang}`} />
            <span className="chk-option-active theme-language-bar-selected">{selectedLang.text}</span>
          </a>
        )}

        <Menu id="lock-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={this.close}>
          {options.map(option => (
            <LangItem key={option.lang} selected={lang === option.lang} option={option} onSelect={this.selectLang} />
          ))}
        </Menu>
      </div>
    );
  }
}
